import React, { memo } from 'react';
import MediaPlayer from 'react-player';
import { CImage } from '@coreui/react-pro';

import { getFileData } from '../../../utils';
import { REGEX_EMBED, REGEX_SCRIPT, REGEX_WISTIA, REGEX_YOUTUBE } from '../../../constants';

const Media = ({ fileName, src, thumbnail, width, height, editInAccordion, viewInAccordion }) => {
     const fileData = getFileData(src);
     const flagTypeFile = ['jpg', 'jpeg', 'png', 'jfif', 'webp', 'gif', 'svg'];

     const isEmbed = REGEX_EMBED.test(src);
     const isScript = REGEX_SCRIPT.test(src);
     const isVideoYoutube = REGEX_YOUTUBE.test(src);
     const isVideoWistia = REGEX_WISTIA.test(src);

     const htmlVideo = (value) => {
          return value.substr(value.indexOf('<div'), value.lastIndexOf('</div>'));
     };

     const RenderMedia = () => {
          if (isScript && !isVideoWistia) {
               return <div className="media w-100" dangerouslySetInnerHTML={{ __html: htmlVideo(src) }} />;
          }

          if (isEmbed || isVideoYoutube || isVideoWistia) {
               return (
                    <div className="video-wrapper">
                         <div className="video">
                              <MediaPlayer url={src} controls={true} className="the-player" width="100%" height="100%" />
                         </div>
                    </div>
               );
          }

          return (
               <>
                    {fileData.extension === 'mp4' ? (
                         <video width="320" height="240" controls>
                              <source src={src} type="video/mp4" />
                         </video>
                    ) : (
                         <>
                              {fileData.extension && flagTypeFile.includes(fileData.extension.toLowerCase()) && (
                                   <CImage thumbnail={thumbnail} className="image-wrap" fluid src={src} width={width} height={height} />
                              )}
                         </>
                    )}
               </>
          );
     };

     return <RenderMedia />;
};

Media.defaultProps = {
     thumbnail: false,
     src: '',
};

export default memo(Media);
